import axios from 'axios';

export const createNotification = (branchID, data, token) => {
    const newURL = `/notification/${branchID}/make_notification`;
    return axios.post(newURL, data, {
        headers: { Authorization: token }
    });
};

export const takeNotification = (branchID, type = 'all', token) => {
    const newURL = `/notification/${branchID}/take_notification/${type}`;
    return axios.get(newURL, {
        headers: { Authorization: token }
    });
};

export const updateNotification = (branchID, id, token) => {
    const newURL = `/notification/${branchID}/update_notification/${id}`;
    return axios.patch(newURL, {}, {
        headers: { Authorization: token }
    });
};

export const updateAllNotification = (branchID, token) => {
    const newURL = `/notification/${branchID}/update_all_notification`;
    return axios.patch(newURL, {}, {
        headers: { Authorization: token }
    });
};
